{
    "NAME": "ConfigChangeLogListLanguage",
    "ConfigChangeLogList_Column_Description": "Descrição",
    "ConfigChangeLogList_Column_DateTime": "Data\/Hora",
    "ConfigChangeLogList_Column_User": "Usuário",
    "ConfigChangeLogList_Column_Action": "Ação",
    "ConfigChangeLogList_Column_Type": "Tipo",
    "ConfigChangeLogList_Column_CME": "Educação Médica Continuada",
    "ConfigChangeLogList_Column_TelSys": "Servidor de telefonia",
    "ConfigChangeLogList_Column_Partition": "Partição",
    "ConfigChangeLogList_Filter_Before": "Antes",
    "ConfigChangeLogList_Filter_Actions": "Ações",
    "ConfigChangeLogList_Filter_EntityTypes": "Tipos de entidade",
    "ConfigChangeLogList_Filter_MultiSelectedCount": "[{} selecionado]",
    "ConfigChangeLogList_Filter_SearchUsername": "Pesquisar nome de usuário",
    "ConfigChangeLogList_Filter_SuppressNulls": "Suprimir valores nulos",
    "ConfigChangeLogList_Filter_SuppressNulls_No": "Não",
    "ConfigChangeLogList_Filter_SuppressNulls_Yes": "Sim",
    "ConfigChangeLogList_Filter_ActionDescription_All": "[Todos]",
    "ConfigChangeLogList_Filter_ActionDescription_INSERT": "Inserir",
    "ConfigChangeLogList_Filter_ActionDescription_UPDATE": "Atualizar",
    "ConfigChangeLogList_Filter_ActionDescription_DELETE": "Excluir",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN": "Conecte-se",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_FAILED": "falha no login",
    "ConfigChangeLogList_Filter_ActionDescription_LOGIN_AS": "Entrar como",
    "ConfigChangeLogList_Filter_ActionDescription_SYNC_REQUESTED": "Sincronização solicitada",
    "ConfigChangeLogList_Filter_TypeDescription_All": "[Todos]",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgents": "Agentes ACD",
    "ConfigChangeLogList_Filter_TypeDescription_ACDAgentsOwned": "Agentes da ACD possuíam (associações)",
    "ConfigChangeLogList_Filter_TypeDescription_Devices": "Dispositivos",
    "ConfigChangeLogList_Filter_TypeDescription_DevicesOwned": "Dispositivos de propriedade (assinaturas)",
    "ConfigChangeLogList_Filter_TypeDescription_DNISAssociations": "Associações DNIS",
    "ConfigChangeLogList_Filter_TypeDescription_Codes": "Códigos",
    "ConfigChangeLogList_Filter_TypeDescription_CallRecordingIntegrations": "Integrações de gravação de chamadas",
    "ConfigChangeLogList_Filter_TypeDescription_Partitions": "Partições",
    "ConfigChangeLogList_Filter_TypeDescription_TelephoneSystems": "Sistemas telefônicos",
    "ConfigChangeLogList_Filter_TypeDescription_Users": "Usuários",
    "ConfigChangeLogList_Filter_TypeDescription_CRMConfiguration": "Configuração do CRM",
    "ConfigChangeLogList_Detail_Title": "Registro de auditoria",
    "ConfigChangeLogList_Detail_SummaryColumnItem": "Item",
    "ConfigChangeLogList_Detail_SummaryColumnValue": "Valor",
    "ConfigChangeLogList_Detail_Field": "Campo",
    "ConfigChangeLogList_Detail_OldValue": "Valor antigo",
    "ConfigChangeLogList_Detail_NewValue": "Novo valor"
}